import { Box } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-black py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10  rounded-lg flex items-center justify-center">
                <img
                  src="/beeboxlogo.png"
                  alt="Beebox Logo"
                  className="w-10 h-10"
                />
              </div>
              <div>
                <span className="text-2xl font-bold text-white">
                  Beebox<span className="text-[#FFC33A]">3D</span>
                </span>
                <p className="text-xs text-gray-400">by Beebox Studios</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Enterprise 3D, AR, and VR platform suite for sales, training,
              inspections, and operations.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Products</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <a href="#products" className="hover:text-[#FFC33A] transition">
                  SalesBee
                </a>
              </li>
              <li>
                <a href="#products" className="hover:text-[#FFC33A] transition">
                  SkillBee
                </a>
              </li>
              <li>
                <a href="#products" className="hover:text-[#FFC33A] transition">
                  CheckBee
                </a>
              </li>
              <li>
                <a href="#products" className="hover:text-[#FFC33A] transition">
                  Hive
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <a
                  href="https://www.beeboxstudios.com/"
                  className="hover:text-[#FFC33A] transition"
                >
                  About Beebox Studios
                </a>
              </li>
              <li>
                <a href="#why-us" className="hover:text-[#FFC33A] transition">
                  Why Choose Us
                </a>
              </li>
              <li>
                <a href="#signup" className="hover:text-[#FFC33A] transition">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © 2026 Beebox 3D by Beebox Studios. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
